// Module
var code = "<div name=nlgScriptEntityEditionParams class=nlgScriptEntityEditionParams> <fieldset ng-disabled=!isEnabled()> <nlg-generic-param-definition-edition generic-param-definitions=requiredGenericParams> </nlg-generic-param-definition-edition></fieldset> </div> ";
// Exports
module.exports = code;